// Escape HTML null-safe para interpolación en template literals (S2 Fase 1 / T-01).
// Texto plano → SIEMPRE escapeHtml antes de innerHTML/template literals.
// Rich HTML de admin (ActionText) NO pasa por aquí (ver plan S2 Fase 2).
export const escapeHtml = (str) => String(str ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
